module.exports = __webpack_public_path__ + "img/001-neptune.5cf90dec.svg";